export const acceptedLanguages = ['en', 'vi', 'ru']
